<script setup>
import { ref, inject } from 'vue'
import ExplorerSearch from "@/components/explorer/ExplorerSearch.vue"
import FilterPanelItem from "@/components/explorer/filter/FilterPanelItem.vue"
import FilterItemSlider from "@/components/explorer/filter/FilterItemSlider.vue"
import FilterItemRB from "@/components/explorer/filter/FilterItemRB.vue"
import FilterItemCB from "@/components/explorer/filter/FilterItemCB.vue"
import FilterAccordion from "@/components/explorer/filter/FilterAccordion.vue"
import {ChartTypeEnum} from  "@/components/explorer/visualizations/ChartTypeEnum.js"

//events raised by component
const emit = defineEmits([
	'closeFilterPanel',
	'applyFilter',
	'resetFilters'
])

//componenet methods exposed to parent
defineExpose({
    initFilters,
	closeFilterItem
});
const { mapDrilldownState } = inject('mapDrilldownState')

//Reactive field proxies
const dimNames = ref()
const showFilterSlider = ref(false)
const showFilterRB = ref(false)
const showFilterCB = ref(false)
const showFilterAccordion = ref(false)
const disabledDims = ref([])
// const selectedCat = ref({})
//const xAxisDim = ref()
//const selectedCat = ref()

//binding used to invoke method on child component
const childRefFilterItemSlider = ref({})
const childRefFilterItemCB = ref({})
const childRefFilterItemRB = ref({})
const childRefFilterAccordion = ref({})

//local variables
let indicatorObj = null
let chartSettings = null
let chartType = null
let xAxisDim = null
let seriesDim = null
//let categoryObj = null

//Methods
function initFilters(type, ind, settings) {
	indicatorObj = ind
	chartSettings = settings
	chartType = type
	closeFilterItem()
	setDims()
	if(mapDrilldownState.value.dim != null) {
		const dim = dimNames.value.find(x => x.columnName == mapDrilldownState.value.dim)
		openFilterItem(dim, mapDrilldownState.value.selectedArea) 
	}
}

function setDims() {
	xAxisDim = chartSettings.xAxisDim
	seriesDim = chartSettings.seriesDim
	let tmp =[]
	//disabledDims.value = []


	indicatorObj.columns.items.forEach(dim => {
		//No restrictions due to xaxis or series being set, so add all fields that are not hierarchies
		if(xAxisDim == null || seriesDim == null) {
			if(dim.childColumnName == null && (dim.categoryLabelFlag || dim.xAxisFlag)) {
				tmp.push(dim)
			}
		} else if(dim.childColumnName != null || dim.parentColumnName != null ) {
			//If table then always show child instead of parent
			if(ChartTypeEnum.TABLE.chartName == chartType) {
				//Add all valid fields except the parent (showing child)
				if(dim.parentColumnName != null) {
					tmp.push(dim)
				} 
			} else if(dim.columnName == xAxisDim.columnName) {
				//Add except when parent is series
				if(dim.childColumnName != null && dim.childColumnName == seriesDim.columnName) {
					null
				} else {
					tmp.push(dim)
				}
			} else if(dim.columnName == seriesDim.columnName) {
				//add when child or when parent is series and child is not xaxis
				if(dim.parentColumnName != null) {
					tmp.push(dim)
				} else if(dim.childColumnName != null) { //  && xAxisDim.columnName != dim.childColumnName) {
					tmp.push(dim)
				}
			} else if(dim.parentColumnName == xAxisDim.columnName || dim.parentColumnName == seriesDim.columnName) {
				//don't add when parent is xaxis or series
				null
			} 
			else if(dim.parentColumnName != null) {
				tmp.push(dim)
			} 
		//Push child or non hierarchical dims to list
		} else if(dim.categoryLabelFlag || dim.xAxisFlag) {
			tmp.push(dim)
		}	
	})
	dimNames.value = tmp

	//TODO: REMOVE CODE BELOW ONCE API IS RETURNING DIMS IN THE CORRECT METADATA ORDER
	if(xAxisDim != null) {
		//Move X Axis dim to top of list (if the dim is the child of xaxis then move to top since parent is hidden)
		const index = tmp.findIndex(obj => obj.columnName === xAxisDim.columnName || obj.columnName === xAxisDim.childColumnName);
		if (index === -1) {
			dimNames.value = tmp
		} else {
			const dims = tmp.splice(index, 1); // Remove the object
			tmp.unshift(dims[0]); // Add the object to the beginning

			//Move selected Category to 2nd row in list 
			if(xAxisDim.childColumnName == null) {
				const catInd = tmp.findIndex(obj => obj.columnName === seriesDim.columnName);
				if (catInd === -1) {
					dimNames.value = tmp
				} else {
					let cats = tmp.splice(catInd, 1); // Remove the object
					tmp.splice(1, 0, cats[0]); // Add the object to the beginning

					dimNames.value = tmp
				}
			}
		}
	}

}

function closeFilterPanel() {
	//console.log('close')
	emit('closeFilterPanel')
}

function openFilterItem(dim, selectedArea) {
	//Show accordion filter when dim part of hierarchy
	if(dim.nestedColumns && dim.nestedColumns.length > 0) {
		if(ChartTypeEnum.LINE.chartName == chartType || ChartTypeEnum.BAR.chartName == chartType) {
			//do not use accordion when parent is the seriesdim
			if (seriesDim && dim.columnName == seriesDim.columnName ||
				seriesDim && dim.parentColumnName == seriesDim.columnName) {
					showFilterAccordion.value = true
					childRefFilterAccordion.value.initFilterItem(chartType, dim, 'cb')
			} else if (xAxisDim && dim.columnName == xAxisDim.columnName) {
					showFilterAccordion.value = true
					childRefFilterAccordion.value.initFilterItem(chartType, dim, 'cb')
			} else {
				//dim is not xaxis nor series so restrict selections to one value
				showFilterAccordion.value = true
				childRefFilterAccordion.value.initFilterItem(chartType, dim, 'rb')
			}
		} else if(ChartTypeEnum.MAP.chartName == chartType) {
			showFilterAccordion.value = true
			childRefFilterAccordion.value.initFilterItem(chartType, dim, 'cb', selectedArea)
		} else {
			//all other chart types
			showFilterAccordion.value = true
			childRefFilterAccordion.value.initFilterItem(chartType, dim, 'cb')
		}
	} else if(dim.columnName == 'Year') {
		showFilterSlider.value = true
		childRefFilterItemSlider.value.initFilterItem(chartType, dim, xAxisDim, seriesDim)
	} else if(ChartTypeEnum.TABLE.chartName == chartType) {
		showFilterCB.value = true
		childRefFilterItemCB.value.initFilterItem(chartType, dim)
	} else if(ChartTypeEnum.MAP.chartName == chartType && (dim.geoCodeFlag ||dim.geoLabelFlag)) {
		showFilterCB.value = true
		childRefFilterItemCB.value.initFilterItem(chartType, dim)
	} else if (seriesDim && xAxisDim && (dim.columnName == seriesDim.columnName || dim.columnName == xAxisDim.columnName)) {
		showFilterCB.value = true
		childRefFilterItemCB.value.initFilterItem(chartType, dim)
	} else {
		showFilterRB.value = true
		childRefFilterItemRB.value.initFilterItem(chartType, dim)
	}
}

function closeFilterItem(type) {
	showFilterSlider.value = false
	showFilterCB.value = false
	showFilterRB.value = false
	showFilterAccordion.value = false
	if(type == 'all')
		closeFilterPanel();
}

function updateFilter(dim) {
	emit('applyFilter', dim)
}

function isDisabled(dim) {
	return disabledDims.value.findIndex(x => x.columnName == dim.columnName)>-1?true:false
}

function resetAll() {
	// let allVal = dim.totalLabel
	// let totalLabelFound = dim.distinctValues.includes(allVal)
	// dim.appliedValues.forEach(i => {
	// 	if(totalLabelFound && i.name == allVal) {
	// 		i.selected = false;
	// 	} else {
	// 		i.selected = true;
	// 	}
	// })
	emit('resetFilters');
}

</script>

<template>
	<div class="filters-panel">
		<div class="filters-header">
			<button class="btn-icon btn-close" @click="closeFilterPanel" aria-label="Close"><i class="fa-solid fa-times"></i></button>
		</div>
		<div class="filters-title" v-html="'Customize '+(['map','table'].includes(chartType)?(chartType.charAt(0).toUpperCase()+chartType.slice(1)):'Chart')"></div>

		<!--
		<ExplorerSearch />
		-->
		<div class="filters-list">
			<div v-for="(dim, index) in dimNames" :key="index">
				<FilterPanelItem @filterItem="openFilterItem" :disabled="isDisabled(dim)" :dim="dim" />
			</div>
		</div>
		<div v-show="showFilterSlider">
			<FilterItemSlider ref="childRefFilterItemSlider"  @closeFilterItemPanel="closeFilterItem" @updateFilterValue="updateFilter"/>
		</div>
		<div v-show="showFilterCB">
			<FilterItemCB ref="childRefFilterItemCB" @closeFilterItemPanel="closeFilterItem" @updateFilterValue="updateFilter"/>
		</div>
		<div v-show="showFilterRB">
			<FilterItemRB ref="childRefFilterItemRB" @closeFilterItemPanel="closeFilterItem" @updateFilterValue="updateFilter"/>
		</div>
		<div v-show="showFilterAccordion">
			<FilterAccordion ref="childRefFilterAccordion" @closeFilterItemPanel="closeFilterItem" @updateFilterValue="updateFilter"/>
		</div>

		<div class="button-section">
			<button class="btn-primary" @click="resetAll"> <i class="fa-solid fa-trash-can-undo"></i> Reset All </button>
		</div>
	</div>
</template>

<style scoped>
.filters-panel {
	display: flex;
	width: 25rem; /* 400px; */
	flex-direction: column;
	align-items: flex-start;
	gap: var(--spacing-xl, 1.5rem);
	flex-shrink: 0;
    padding: .75rem 1.25rem;
	border-radius: var(--ui-cards-default, 0.75rem);
	background: var(--surface-color-Default, #FFF);
	/*min-height: 50.375rem; /*806px; */
	/* UI Card */
	box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.15);
	position: relative;
}
.filters-header {
	display: flex;
	width: 100%; /* 394px; */
	height: 1.25rem;
	justify-content: end;
}

.filters-title {
	color: var(--text-Header, #171717);

	/* Medium/H6 */
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-H6, 1.25rem);
	font-style: normal;
	font-weight: 500;
	line-height: var(--font-line-height-H6, 1.75rem); /* 140% */
}

.btn-close {
	color: var(--icon-cta-Blue, #064291);
	text-align: right;
	font-weight: 900;
	line-height: normal;
	font-size: var(--font-size-H6);
	min-width: 1rem;
}

.filters-list {
	display: flex;
	padding-inline-start: 0;
	flex-direction: column;
	align-items: flex-start;
	align-self: stretch;
	list-style-type: none;
	overflow-y: auto;
	overflow-x: hidden;
	/*min-height: 36rem;*/
	flex: 1 1 0;
}

.button-section {
	display: flex;
	justify-content:end;
	width: 100%;
	border-top: 1px solid var(--border-color-Divider);
	margin-top: 1.8rem;
	padding-top: 1rem;
}

/* 499px - Mobile */
@media (max-width: 31.1875rem) {
	.filters-panel {
		position: fixed;
		top: 8.4375rem; /*  135px; */
		left: 0;
		width: calc(100vw);
		height: calc(100vh);
	}
}

/* 1023px - iPad */
@media (max-width: 63.9375rem) {
	.filters-panel {
		position: absolute;
		top: 8.5rem;
		left: 0;
		width: 100%;
		border-radius: 0;
		z-index: 99;
	}
}
</style>
